import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { formatISOToDDMMYY } from "@/utils/dateFormatter";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

interface PropertySidebarItemProps {
  id: string;
  title: string;
  shortName: string;
  operationStartedAt: string;
  imageUrl: string;
  available: boolean;
  rowHeight: number;
  columnWidth: number;
}

const PropertySidebarItem = ({
  id,
  title,
  shortName,
  operationStartedAt,
  imageUrl,
  available,
  rowHeight,
  columnWidth,
}: PropertySidebarItemProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <Link
        to={`/admin/properties/edit/${id}`}
        aria-label={`Ir a ${title}`}
        className="group relative flex items-center border-b gap-2 pl-2 pr-4 py-1 hover:bg-gray-100 transition"
        style={{
          height: rowHeight,
          width: columnWidth,
          minWidth: columnWidth,
          maxWidth: columnWidth,
        }}
      >
        <div className="flex items-center gap-2 flex-1 min-w-0 group-hover:blur-sm transition-all">
          <div className="relative w-10 h-10 flex-shrink-0 rounded-md overflow-hidden">
            <img
              src={imageUrl}
              alt={title}
              className="w-full h-full object-cover"
            />
            <span
              className={`absolute bottom-[1px] right-[1px] w-2 h-2 rounded-full ring-2 ring-white ${
                available ? "bg-green-500" : "bg-gray-400"
              }`}
            />
          </div>

          <div className="flex flex-col flex-1 min-w-0 space-y-0.5">
            <span className="text-xs font-semibold text-gray-900 truncate">
              {title}
            </span>

            <span className="text-xs text-gray-500 truncate">{shortName}</span>
          </div>
        </div>

        <div className="absolute right-1 hidden group-hover:flex items-center z-10">
          <ChevronRight className="w-6 h-6 text-gray-400 hover:text-black transition-colors" />
        </div>
      </Link>
    </TooltipTrigger>

    <TooltipContent
      className="break-words text-center w-fit space-y-0.5"
      style={{ maxWidth: columnWidth }}
    >
      <div className="text-sm font-medium text-gray-900">{title}</div>
      <div className="text-[11px] text-gray-500">
        Inicio: {operationStartedAt ? formatISOToDDMMYY(operationStartedAt) : "N/A"}
      </div>
    </TooltipContent>
  </Tooltip>
);

export default PropertySidebarItem;
